import { colorsPalettes } from "@similarweb/styles";
import { DropdownItem } from "@similarweb/ui-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled, { css } from "styled-components";

export const StyledDropdownItem = styled(DropdownItem)`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-right: 16px;

    & > span {
        color: ${colorsPalettes.black["0"]};
    }

    ${({ disabled }) => {
        if (disabled) {
            return css`
                cursor: not-allowed;

                & > span {
                    color: ${colorsPalettes.red["s100"]};
                }
            `;
        }
    }};
`;

export const StyledHeaderText = styled.span`
    color: rgba(42, 62, 82, 0.6);
    font-size: 12px;
    font-weight: 500;
    line-height: 40px;
`;

export const StyledHeader = styled(FlexRow)`
    background-color: ${colorsPalettes.carbon["0"]};
    border-bottom: 1px solid ${colorsPalettes.carbon["100"]};
    height: 40px;
    padding: 0 16px;
    user-select: none;
`;

export const StyledDDContainer = styled.div`
    position: relative;
`;
